import { getAttributeValue, setAttributeValue, clearAttributeValue } from './utils';

const pageInfo = {
    state: {
        // 页面名称：默认值为监控一张图
        pageName: '',
        // 页面地址：默认值为监控一张图URL
        pageUrl: '',
    },
    getters: {
        // 获取页面名称
        getPageName(state) {    
            return getAttributeValue(state, "pageName");
        },
        // 获取页面地址
        getPageUrl(state) {
            return getAttributeValue(state, "pageUrl");
        }
    },
    mutations: {
        // 设置页面名称
        SET_PAGE_NAME: (state, pageName) => {
            setAttributeValue(state, "pageName", pageName);
        },
        // 设置页面URL
        SET_PAGE_URL: (state, pageUrl) => {
            setAttributeValue(state, "pageUrl", pageUrl);
        },
        // 清除页面缓存
        CLEAR_PAGE_INFO: (state) => {
            state.pageName = "";
            state.pageUrl = "";
            // 同步清除session
            clearAttributeValue("pageName");
            clearAttributeValue("pageUrl");
        }
    },
    actions: {
        // 设置页面名称
        setPageName({ commit }, pageName) {
            commit('SET_PAGE_NAME', pageName);
        },
        // 设置用户名称
        setPageUrl({ commit }, pageUrl) {
            commit('SET_PAGE_URL', pageUrl);
        },
        // 清除缓存
        clearPageInfo: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_PAGE_INFO');
        }
    }
}

export default pageInfo;


// WEBPACK FOOTER //
// ./src/store/modules/page-info.js